var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { SliceStopCountFilter, } from "../../flights-module";
import { RoomProductType, } from "../../hotels-module";
import { EligibilitySegmentEnum, ExerciseEligibilityV1Enum, FlightDisruptionEnum, FlightDisruptionReasonEnum, getEligibleSliceFromEligibility, HotelCfarCancelScenarioEnum, } from "../../trips-module";
import { Dealness, PushNotificationFilter, ShopFilter } from "./shop-summary";
dayjs.extend(utc);
// COMMON EVENTS
export var ADD_CONTACT_INFO = "add_contact_info";
export var ADD_TRAVELER = "add_traveler";
export var SELECT_TRAVELERS = "select_travelers";
export var SELECT_REWARDS = "select_rewards";
export var ADD_PAYMENT = "add_payment";
export var TRIGGERED_ERROR_BOUNDARY = "triggered_error_boundary";
export var SELECT_PAYMENT = "select_payment";
export var APPLIED_TRAVEL_CREDITS = "applied_travel_credits";
export var APPLIED_TRAVEL_OFFER = "applied_travel_offer";
export var RESTRICTED_TRAVEL_CREDIT_TOGGLED = "restricted_travel_credit_toggled";
export var EDITED_RESTRICTED_CREDIT_AMOUNT = "edited_restricted_credit_amount";
export var RESTRICTED_TRAVEL_CREDIT_DISPLAYED = "restricted_travel_credit_displayed";
// AIR EVENTS
export var VIEWED_AIR_SEARCH = "viewed_air_search";
export var AIR_ENTRY = "air_entry";
export var CHAT_ENTERED = "chat_entered";
export var AIR_MULTICITY_ENTRY = "air_multicity_entry";
export var VIEWED_FORECAST = "viewed_forecast";
export var VIEWED_FLIGHT_LIST = "viewed_flight_list";
export var VIEWED_MULTICITY_FLIGHT_LIST = "viewed_multicity_flight_list";
export var VIEWED_DURATION_SLIDER = "viewed_duration_slider";
export var CONTINUE_DURATION_SLIDER = "continue_duration_slider";
export var APPLIED_FILTER = "applied_filter";
export var VIEWED_SLICE = "viewed_slice";
export var VIEWED_MULTICITY_SLICE = "viewed_multicity_slice";
export var SELECTED_FLIGHT = "selected_flight";
export var SELECTED_MULTICITY_FLIGHT = "selected_multicity_flight";
export var VIEWED_TRIP_SUMMARY = "viewed_trip_summary";
export var VIEWED_MULTICITY_TRIP_SUMMARY = "viewed_multicity_trip_summary";
export var ADD_FREQUENT_FLYER = "add_frequent_flyer";
export var ADD_PASSPORT = "add_passport";
export var VIEW_ITINERARY_RESTRICTIONS = "view_itinerary_restrictions";
export var REVIEW_FLIGHT_DETAILS = "review_flight_details";
export var REVIEW_MULTICITY_FLIGHT_DETAILS = "review_multicity_flight_details";
export var AIR_SAVE_AND_CONTINUE_CLICKED = "air_save_and_continue_clicked";
export var AIR_PRICE_QUOTE_TO_BOOK_REQUEST_RUNTIME = "air_price_quote_to_book_request_runtime";
export var PRICE_QUOTE_AIR = "price_quote_air";
export var PRICE_QUOTE_MULTICITY_AIR = "price_quote_multicity_air";
export var COMPLETE_BUY_AIR = "complete_buy_air";
export var COMPLETE_BUY_MULTICITY_AIR = "complete_buy_multicity_air";
export var getPriceAlertPreferenceProperties = function (pushNotificationFilter) {
    return {
        push_eligibile: !!pushNotificationFilter,
        channel: pushNotificationFilter === PushNotificationFilter.AppNotifications
            ? "push"
            : "email",
    };
};
export var VIEWED_WATCH = "viewed_watch";
export var ADDED_WATCH = "added_watch";
export var SELECTED_WATCH_PUSH = "selected_watch_push";
export var WatchFilterType;
(function (WatchFilterType) {
    WatchFilterType["NonStopExcludeLCC"] = "non_stop_exclude_LCC";
    WatchFilterType["NonStopIncludeLCC"] = "non_stop_include_LCC";
    WatchFilterType["AnyStopsExcludeLCC"] = "any_stops_exclude_LCC";
    WatchFilterType["AnyStopsIncludeLCC"] = "any_stops_include_LCC";
})(WatchFilterType || (WatchFilterType = {}));
export var getWatchFilterTypeFromShopFilter = function (shopFilter) {
    switch (shopFilter) {
        case ShopFilter.NonStopNoLCC:
            return WatchFilterType.NonStopExcludeLCC;
        case ShopFilter.NonStop:
            return WatchFilterType.NonStopIncludeLCC;
        case ShopFilter.NoLCC:
        case ShopFilter.ShortLayoverNoLCC:
            return WatchFilterType.AnyStopsExcludeLCC;
        case ShopFilter.ShortLayover:
        case ShopFilter.NoFilter:
        case undefined:
            return WatchFilterType.AnyStopsIncludeLCC;
    }
};
export var getWatchFilterTypeFromFlightShopParams = function (stopOption, noLcc) {
    if (noLcc) {
        switch (stopOption) {
            case SliceStopCountFilter.NONE:
                return WatchFilterType.NonStopExcludeLCC;
            default:
                return WatchFilterType.AnyStopsExcludeLCC;
        }
    }
    else {
        switch (stopOption) {
            case SliceStopCountFilter.NONE:
                return WatchFilterType.NonStopIncludeLCC;
            default:
                return WatchFilterType.AnyStopsIncludeLCC;
        }
    }
};
export var APPLIED_FREQUENT_FLYER = "applied_frequent_flyer";
export var SKIPPED_SEAT_SELECTION = "skipped_seats_selection";
export var REQUESTED_SEATMAP = "requested_seatmap";
export var VIEWED_SEATMAP = "viewed_seatmap";
export var CHOSE_FROM_SEATMAP = "chose_from_seatmap";
export var CHANGED_TRIP_TYPE = "changed_trip_type";
export var CHANGED_PAX_COUNT = "changed_pax_count";
// HOTEL EVENTS
export var HOTEL_ENTRY = "hotel_entry";
export var VIEWED_HOTEL_LIST = "viewed_hotel_list";
export var VIEWED_LODGING_IN_LIST = "viewed_lodging_in_list";
export var VIEWED_CURATED_HOTEL = "viewed_curated_hotel";
export var CLICKED_CURATED_HOTEL = "clicked_curated_hotel";
export var VIEWED_UNAVAILABLE_HOTEL_LIST = "viewed_unavailable_hotel_list";
export var SELECTED_UNAVAILABLE_HOTEL_FROM_LIST = "selected_unavailable_hotel_from_list";
export var APPLIED_HOTEL_FILTER = "applied_hotel_filter";
export var APPLIED_PREMIUM_SEARCH_FILTER = "applied_premium_search_filter";
export var PremiumStaysFunnel;
(function (PremiumStaysFunnel) {
    PremiumStaysFunnel["LuxuryHotel"] = "luxury_hotel";
    PremiumStaysFunnel["LuxuryVR"] = "luxury_vr";
})(PremiumStaysFunnel || (PremiumStaysFunnel = {}));
export var PremiumStaysFilterType;
(function (PremiumStaysFilterType) {
    PremiumStaysFilterType["ResetFilters"] = "reset_filters";
    PremiumStaysFilterType["AllFilters"] = "all_filters";
    PremiumStaysFilterType["SortBy"] = "sort_by";
    PremiumStaysFilterType["Amenities"] = "amenities";
    PremiumStaysFilterType["Rating"] = "rating";
    PremiumStaysFilterType["FreeCancellation"] = "free_cancellation";
    PremiumStaysFilterType["Bedrooms"] = "bedrooms";
    PremiumStaysFilterType["Beds"] = "beds";
    PremiumStaysFilterType["Bathrooms"] = "bathrooms";
    PremiumStaysFilterType["MaxPrice"] = "max_price";
    PremiumStaysFilterType["HotelName"] = "hotel_name";
    PremiumStaysFilterType["MealPlan"] = "meal_plan";
})(PremiumStaysFilterType || (PremiumStaysFilterType = {}));
export var SELECTED_HOTEL_FROM_LIST = "selected_hotel_from_list";
// When a hotel/VR modal is clicked and the cover page is opened
export var SELECTED_HOTEL_FROM_MAP = "selected_hotel_from_map";
// When the "Search this area" button is clicked on the map
export var SEARCH_THIS_AREA = "search_this_area";
// When a marker (hotel, stay, cluster) is clicked on the map (opens the map modal or expands the cluster)
export var CLICKED_LODGING_MAP = "clicked_lodging_map";
export var ClickedLodgingMapEnum;
(function (ClickedLodgingMapEnum) {
    ClickedLodgingMapEnum["HOTEL"] = "hotel";
    ClickedLodgingMapEnum["VACATION_RENTAL"] = "vacation_rental";
    ClickedLodgingMapEnum["CLUSTER"] = "cluster";
})(ClickedLodgingMapEnum || (ClickedLodgingMapEnum = {}));
export var MapFunnelEnum;
(function (MapFunnelEnum) {
    MapFunnelEnum["STAYS"] = "stays";
    MapFunnelEnum["PACKAGES"] = "packages";
})(MapFunnelEnum || (MapFunnelEnum = {}));
export var VIEWED_HOTEL_DETAILS = "viewed_hotel_details";
export var SEARCH_DISTANCE_FROM_SHOP = "search_distance_from_shop";
export var VIEWED_HOTEL_SHOP_MAP = "viewed_hotel_shop_map";
export var VIEW_HOTELS_NEAR = "view_hotels_near";
export var ADD_DRIVERS_LICENSE = "add_drivers_license";
export var SELECT_HOTEL_ROOM = "select_hotel_room";
export var REVIEW_DETAILS_HOTEL_CHECKOUT = "review_details_hotel_checkout";
export var HOTEL_SAVE_AND_CONTINUE_CLICKED = "hotel_save_and_continue_clicked";
export var PRICE_QUOTE_HOTEL = "price_quote_hotel";
export var PRICE_QUOTE_VR = "price_quote_vr";
export var COMPLETE_BUY_HOTEL = "complete_buy_hotel";
export var SELECTED_RECOMMENDED_HOTEL = "selected_recommended_hotel";
export var HOTEL_LIST_MAP_CAROUSEL = "hotel_list_map_carousel";
export var ADD_HOTEL_LOYALTY = "add_hotel_loyalty";
// CARS EVENTS
export var VIEWED_CARS_SEARCH = "viewed_cars_search";
export var CARS_ENTRY = "cars_entry";
export var VIEWED_CARS_LIST = "viewed_cars_list";
export var APPLIED_CARS_FILTER = "applied_cars_filter";
export var SELECTED_CAR_FROM_LIST = "selected_car_from_list";
export var VIEWED_CAR_DETAILS = "viewed_car_details";
export var REVIEWED_CAR_DETAILS_CHECKOUT = "reviewed_car_details_checkout";
export var CAR_SAVE_AND_CONTINUE_CLICKED = "car_save_and_continue_clicked";
export var PRICE_QUOTE_CAR = "price_quote_car";
export var COMPLETE_BUY_CARS = "complete_buy_car";
export var ADD_HERTZ_LOYALTY_REWARDS = "add_hertz_loyalty_rewards";
// MY TRIPS EVENTS
export var VIEWED_MY_TRIPS = "viewed_my_trips";
export var VIEWED_CONTACT_MODAL = "viewed_contact_modal";
export var WATCH_ENTRY = "watch_entry";
export var SELECT_WATCHED_FLIGHT = "select_watched_flight";
export var STOPPED_WATCH = "stopped_watch";
export var VIEWED_MAJOR_SCHEDULE_CHANGE = "viewed_major_schedule_change";
export var USER_ACTION_SCHEDULE_CHANGE_SUCCESS = "user_action_schedule_change_success";
export var SCHEDULE_CHANGE_DECISION = "schedule_change_decision";
export var AUTO_ACCEPT = "auto_accept";
// ONBOARDING EVENTS
export var VIEWED_ONBOARDING = "viewed_onboarding";
export var COMPLETED_ONBOARDING = "completed_onboarding";
export var SKIPPED_ONBOARDING = "skipped_onboarding";
// FTUX
export var PRICE_DROP_CREDIT = "price_drop_credit";
export var getPriceBucketValueFromDealness = function (dealness) {
    switch (dealness) {
        case Dealness.Wait:
            return "wait";
        case Dealness.Fair:
            return "fair_price";
        case Dealness.Good:
            return "good_price";
        case Dealness.Great:
            return "great_price";
        default:
            return null;
    }
};
export var PRICE_DROP_VIEWED = "price_drop_viewed";
export var VIEWED_PRICE_DROP_DETAILS = "viewed_price_drop_details";
export var PRICE_DROP_ADDED = "price_drop_added";
export var PRICE_DROP_REFUND_RECEIVED = "price_drop_refund_received";
export var CREDITS_ISSUED = "credits_issued";
export var LAUNCHED_APPLICATION = "launched_application";
export var LOGGED_IN = "logged_in";
export var LAUNCHED_MOBILE_LOCATION_SCREEN = "launched_mobile_location_screen";
export var AUTOCOMPLETE_LOCATION_SELECTED = "autocomplete_location_selected";
export var LAUNCHED_MOBILE_CALENDAR = "launched_mobile_calendar";
export var CALENDAR_DATES_SELECTED = "calendar_dates_selected";
export var NETWORK_CALL_FAILED = "network_call_failed";
export var MODAL_ALERT = "modal_alert";
export var MODAL_ALERT_CHOICE = "modal_alert_choice";
export var VIEWED_TAKEOVER = "viewed_takeover";
export var TAPPED_TAKEOVER_CHOICE = "tapped_takeover_choice";
export var ModalCategoryType;
(function (ModalCategoryType) {
    ModalCategoryType["FEATURE"] = "feature";
    ModalCategoryType["TROUBLE"] = "trouble";
})(ModalCategoryType || (ModalCategoryType = {}));
export var ModalScreens;
(function (ModalScreens) {
    ModalScreens["CARS_AVAILABILITY"] = "cars availability";
    ModalScreens["CARS_CHECKOUT"] = "cars checkout";
    ModalScreens["CARS_SHOP"] = "cars shop";
    ModalScreens["CARS_SEARCH"] = "cars search";
    ModalScreens["FLIGHTS_CHECKOUT"] = "flights checkout";
    ModalScreens["FLIGHTS_SEARCH"] = "flights search";
    ModalScreens["HOTELS_AVAILABILITY"] = "hotels availability";
    ModalScreens["HOTELS_SHOP"] = "hotels details";
    ModalScreens["HOTELS_CHECKOUT"] = "hotels checkout";
    ModalScreens["HOTELS_SEARCH"] = "hotels search";
    ModalScreens["FLIGHTS_AVAILABILITY"] = "flights availability";
    ModalScreens["DISRUPTION_REBOOKING"] = "disruption_rebooking";
    ModalScreens["MY_TRIPS"] = "my trips";
    ModalScreens["ADD_WATCH_FLIGHT_LIST"] = "add watch flight list";
    ModalScreens["VR_CHECKOUT"] = "vr checkout";
    ModalScreens["VR_DETAILS"] = "vr details";
    ModalScreens["FLIGHTS_SHOP"] = "flights shop";
    ModalScreens["PACKAGES_CHECKOUT"] = "packages checkout";
    ModalScreens["PACKAGES_AVAILABILITY"] = "packages availability";
    ModalScreens["EXPERIENCES_CHECKOUT"] = "experiences checkout";
    ModalScreens["EXPERIENCES_AVAILABILITY"] = "experiences availability";
    ModalScreens["EXPERIENCES_SHOP"] = "experiences shop";
    ModalScreens["PREMIUM_STAYS_LANDING"] = "premium stays landing";
    ModalScreens["PREMIUM_OFFERS_SEARCH"] = "premium offers search";
    ModalScreens["PREMIUM_HOTELS_DATELESS_SEARCH"] = "premium hotels dateless search";
})(ModalScreens || (ModalScreens = {}));
export var CorpModalScreens;
(function (CorpModalScreens) {
    CorpModalScreens["ONBOARDING_WELCOME"] = "onboarding welcome";
    CorpModalScreens["ONBOARDING_LIST"] = "onboarding list";
    CorpModalScreens["ONBOARDING_DETAILS"] = "onboarding details";
    CorpModalScreens["ONBOARDING_ADDITIONAL"] = "onboarding additional";
    CorpModalScreens["ONBOARDING_POLICY"] = "onboarding policy";
    CorpModalScreens["YOU_ARE_ALL_SET"] = "you_are_all_set";
})(CorpModalScreens || (CorpModalScreens = {}));
export var ModalButtonType;
(function (ModalButtonType) {
    ModalButtonType["PRIMARY"] = "primary";
    ModalButtonType["SECONDARY"] = "secondary";
    ModalButtonType["CLOSE"] = "close";
})(ModalButtonType || (ModalButtonType = {}));
export var VIEWED_FLIGHT_SHOP_LOADING = "viewed_flight_shop_loading";
export var VIEWED_FLIGHT_BOOK_PROCESSING = "viewed_flight_book_processing";
export var VIEWED_HOTEL_AVAILABILITY_LOADING = "viewed_hotel_availability_loading";
export var VIEWED_HOTEL_SHOP_LOADING = "viewed_hotel_shop_loading";
export var VIEWED_HOTEL_BOOK_PROCESSING = "viewed_hotel_book_processing";
export var VIEWED_PC_AVAILABILITY_LOADING = "viewed_pc_availability_loading";
export var VIEWED_PC_SHOP_LOADING = "viewed_pc_shop_loading";
export var VIEWED_PC_BOOK_PROCESSING = "viewed_pc_book_processing";
export var VIEWED_CAR_AVAILABILITY_LOADING = "viewed_car_availability_loading";
export var VIEWED_CAR_SHOP_LOADING = "viewed_car_shop_loading";
export var VIEWED_CAR_BOOK_PROCESSING = "viewed_car_book_processing";
export var NO_AVAILABILITY_AIR = "no_availability_air";
export var NO_AVAILABILITY_HOTELS = "no_availability_hotels";
export var NO_AVAILABILITY_CARS = "no_availability_cars";
export var CHARGE_BOOKING_AGENT_FEE = "charge_booking_agent_fee";
export var SelfServeEvents;
(function (SelfServeEvents) {
    SelfServeEvents["ClickCancel"] = "self_serve_click_cancel_button";
    SelfServeEvents["ClickSupport"] = "self_serve_click_support";
    SelfServeEvents["ClickRedirectToCarrier"] = "self_serve_redirect_to_carrier";
    SelfServeEvents["ClickSeatsLink"] = "self_serve_clicked_seats_airline_link";
    SelfServeEvents["ConfirmCancellation"] = "self_serve_confirm_cancellation";
    SelfServeEvents["RedirectToAirline"] = "self_serve_redirect_to_airline";
    SelfServeEvents["ResponseFailure"] = "self_serve_cancel_response_failure";
    SelfServeEvents["ResponseSuccess"] = "self_serve_cancel_response_success";
    SelfServeEvents["ViewedCancelModal"] = "self_serve_viewed_cancel_modal";
    SelfServeEvents["ViewedSavedTravelers"] = "self_serve_saved_travelers_viewlist";
    SelfServeEvents["ClickSavedTravelersAddNew"] = "self_serve_saved_travelers_addnew";
    SelfServeEvents["ClickSavedTravelersSaveTraveler"] = "self_serve_saved_travelers_savechanges";
    SelfServeEvents["ViewedExchangeModal"] = "self_serve_viewed_exchange_modal";
    SelfServeEvents["ViewedExchangeLanding"] = "self_serve_exchange_landingpage";
    SelfServeEvents["ViewedExchangeShopPage"] = "self_serve_exchange_shoppage";
    SelfServeEvents["ViewedExchangeReviewPage"] = "self_serve_exchange_reviewpage";
    SelfServeEvents["ViewedExchangeConfirmPage"] = "self_serve_exchange_confirmpage";
    SelfServeEvents["ViewedTravelerDetailModal"] = "self_serve_traveler_detail_view_modal";
    SelfServeEvents["EditTravelerDetailModal"] = "self_serve_traveler_detail_edit_modal";
    SelfServeEvents["SubmitEditTravelerDetailModal"] = "self_serve_traveler_detail_submit_change";
    SelfServeEvents["FTCExchangeViewedNoResults"] = "self_serve_ftcexchange_viewed_no_results";
    SelfServeEvents["ExchangeNotEligible"] = "self_serve_exchange_not_eligible";
    SelfServeEvents["ExchangeViewedNoResults"] = "self_serve_exchange_viewed_no_results";
    SelfServeEvents["ExchangePriceQuoteSuccess"] = "self_serve_exchange_price_quote_success";
    SelfServeEvents["ExchangePriceQuoteFailure"] = "self_serve_exchange_price_quote_failure";
    SelfServeEvents["ExchangeBookSuccess"] = "self_serve_exchange_book_success";
    SelfServeEvents["ExchangeBookFailure"] = "self_serve_exchange_book_failure";
    SelfServeEvents["ExchangeSubmitSuccess"] = "self_serve_exchange_submitsuccess";
    SelfServeEvents["ExchangeSubmitFailure"] = "self_serve_exchange_submitfailure";
    SelfServeEvents["ViewedFTCExchangeLanding"] = "self_serve_ftcexchange_landingpage";
    SelfServeEvents["ViewedFTCExchangeShopPage"] = "self_serve_ftcexchange_shoppage";
    SelfServeEvents["ViewedFTCExchangeReviewPage"] = "self_serve_ftcexchange_reviewpage";
    SelfServeEvents["ViewedFTCExchangeConfirmPage"] = "self_serve_ftcexchange_confirmpage";
    SelfServeEvents["FTCExchangeNotEligible"] = "self_serve_ftcexchange_not_eligible";
    SelfServeEvents["FTCExchangeSubmitSuccess"] = "self_serve_ftcexchange_submitsuccess";
    SelfServeEvents["FTCExchangeSubmitFailure"] = "self_serve_ftcexchange_submitfailure";
    SelfServeEvents["FTCExchangePriceQuoteSuccess"] = "self_serve_ftc_redeem_price_quote_success";
    SelfServeEvents["FTCExchangePriceQuoteFailure"] = "self_serve_ftc_redeem_price_quote_failure";
    SelfServeEvents["FTCExchangeBookSuccess"] = "self_serve_ftc_redeem_book_success";
    SelfServeEvents["FTCExchangeBookFailure"] = "self_serve_ftc_redeem_book_failure";
    SelfServeEvents["CompletedRequestSelfServe"] = "completed_request_self_serve";
})(SelfServeEvents || (SelfServeEvents = {}));
export var SelfServeCancelScenario;
(function (SelfServeCancelScenario) {
    SelfServeCancelScenario["CfarCancel"] = "cfar_cancel";
})(SelfServeCancelScenario || (SelfServeCancelScenario = {}));
export var VIEWED_RESEND_EMAIL = "viewed_resend_email";
export var CONFIRM_RESEND_EMAIL = "confirm_resend_email";
export var RESEND_EMAIL_SUBMIT = "resend_email_submit";
export var BOOKING_FEE_WAIVED = "booking_fee_waived";
export var CLP_MODAL_VIEW = "CLP_modal_view";
export var CLP_CLICK = "CLP_click";
export var CLPClickEnum;
(function (CLPClickEnum) {
    CLPClickEnum["CHOOSE_ANOTHER_FLIGHT"] = "Choose another flight";
    CLPClickEnum["CONTINUE"] = "Continue";
    CLPClickEnum["EXIT"] = "Exit";
})(CLPClickEnum || (CLPClickEnum = {}));
export var CHANGE_FLIGHT = "change_flight";
export var EDIT_TRAVELERS = "edit_travelers";
export var EDIT_CONTACT = "edit_contact";
export var CAP1_VIEW_BOOKING_ADD_ON = "cap1_view_booking_add_on";
export var CFAR_ADD_ON_CHOICE = "cfar_add_on_choice";
export var CHFAR_ADD_ON_CHOICE = "chfar_add_on_choice";
export var DISRUPTION_ADD_ON_CHOICE = "disruption_add_on_choice";
export var TRIPS_LOADING_COMPLETE = "trips_loading_complete";
// CFAR Exercise Events
export var VIEWED_CFAR_OFFER_OPTIONS = "cap1_viewed_cfar_offer_options";
export var TAPPED_CFAR_OFFER_OPTIONS = "cap1_tapped_cfar_offer_options";
export var VIEWED_CFAR_OFFER = "cap1_viewed_cfar_offer";
export var SELF_SERVE_CLICK_SUPPORT = "self_serve_click_support";
export var SELF_SERVE_CONFIRM_CANCELLATION = "self_serve_confirm_cancellation";
export var SELF_SERVE_CANCEL_RESPONSE_SUCCESS = "self_serve_cancel_response_success";
export var SELF_SERVE_CANCEL_RESPONSE_FAILURE = "self_serve_cancel_response_failure";
export var CfarCancellationOutcome;
(function (CfarCancellationOutcome) {
    // CfarCash corresponds to one of the following:
    // 1) cash-only option was returned from the backend
    // 2) choice option was returned from the backend and the user chose cash
    CfarCancellationOutcome["CfarCash"] = "cfar_cash";
    // CfarFtc = CfarCashOrCfarFtc was returned from the backend and the user chose FTC
    CfarCancellationOutcome["CfarFtc"] = "cfar_ftc";
    // CfarFtcWithPenalty = CfarCashOrCfarFtcWithPenalty was returned from the backend and the user chose FTC
    CfarCancellationOutcome["CfarFtcWithPenalty"] = "cfar_ftc_with_penalty";
    CfarCancellationOutcome["CfarCashOrCfarFtc"] = "cfar_cash_or_cfar_ftc";
    CfarCancellationOutcome["CfarCashOrCfarFtcWithPenalty"] = "cfar_cash_or_cfar_ftc_with_penalty";
    CfarCancellationOutcome["TicketedVoid"] = "ticketed_void";
    CfarCancellationOutcome["AirlineFullRefund"] = "airline_full_refund";
    CfarCancellationOutcome["AirlinePartialRefundOrCfarCash"] = "airline_partial_refund_or_cfar_cash";
    CfarCancellationOutcome["TooCloseToDeparture"] = "too_close_to_departure";
    CfarCancellationOutcome["ContactCustomerService"] = "contact_customer_service";
    CfarCancellationOutcome["CancellationPending"] = "cancellation_pending";
    CfarCancellationOutcome["Unrecognized"] = "unrecognized";
    CfarCancellationOutcome["Error"] = "error";
})(CfarCancellationOutcome || (CfarCancellationOutcome = {}));
export var CfarOfferChoice;
(function (CfarOfferChoice) {
    CfarOfferChoice["CfarCash"] = "cfar_cash";
    CfarOfferChoice["CfarFtc"] = "cfar_ftc";
    CfarOfferChoice["CfarFtcWithPenalty"] = "cfar_ftc_with_penalty";
    CfarOfferChoice["Error"] = "error";
})(CfarOfferChoice || (CfarOfferChoice = {}));
export var CfarEvents;
(function (CfarEvents) {
    CfarEvents["RebookingFeeWaived"] = "cfar_ftcexchange_rebookfeewaived";
})(CfarEvents || (CfarEvents = {}));
export var getHotelCfarExerciseFactsFromCfarContractAndReservation = function (props) {
    var reservation = props.reservation, cfar = props.cfar, cfarCancelScenario = props.cfarCancelScenario;
    var pricing = reservation.pricing, bedTypes = reservation.bedTypes, checkInDate = reservation.checkInDate, checkOutDate = reservation.checkOutDate;
    var payNowTotal = pricing.payNowTotal, subtotal = pricing.subtotal, taxes = pricing.taxes;
    var premium = (cfar !== null && cfar !== void 0 ? cfar : {}).premium;
    var basePriceWithTaxes = subtotal.fiat.value + taxes.fiat.value;
    var cfarFee = premium === null || premium === void 0 ? void 0 : premium.amount.fiat.value;
    var nights = dayjs(checkOutDate).diff(checkInDate, "day");
    return {
        cancel_scenario: SelfServeCancelScenario.CfarCancel,
        cfar_outcome: CfarCancellationOutcome.CfarCash,
        // price paid with cfar fee and any other add ons included
        total_price_usd: payNowTotal.fiat.value,
        // price paid with cfar fee included
        price_per_night: nights > 0 && cfarFee !== undefined
            ? (basePriceWithTaxes + cfarFee) / nights
            : undefined,
        // price paid without cfar fee or any other add ons
        subtotal_usd: basePriceWithTaxes,
        // price paid without taxes and fees or any other add ons
        base_total_usd: subtotal.fiat.value,
        // cfar fee
        charged_cfar_total_usd: cfarFee,
        // cfar fee per night
        charged_cfar_per_night: nights > 0 && cfarFee !== undefined ? cfarFee / nights : undefined,
        rooms_booked: bedTypes.rooms.length,
        cancellation_policy: cfarCancelScenario === null || cfarCancelScenario === void 0 ? void 0 : cfarCancelScenario.HotelCfarCancelScenario,
        advance: dayjs(reservation.checkInDate).diff(dayjs(cfar === null || cfar === void 0 ? void 0 : cfar.purchased), "d"),
        days_until_check_in: dayjs(reservation.checkInDate).diff(dayjs(), "d"),
        cfar_fee_is_refundable: (cfarCancelScenario === null || cfarCancelScenario === void 0 ? void 0 : cfarCancelScenario.HotelCfarCancelScenario) ===
            HotelCfarCancelScenarioEnum.CfarRefundable
            ? !!cfarCancelScenario.shouldRefundCfarPremium
            : undefined,
    };
};
export var SELECTED_TRAVEL_OFFER = "selected_offer";
export var SelectedTravelOfferScreen;
(function (SelectedTravelOfferScreen) {
    SelectedTravelOfferScreen["FLIGHT_SEARCH"] = "flight_search";
    SelectedTravelOfferScreen["FLIGHT_SHOP"] = "flight_shop";
    SelectedTravelOfferScreen["FLIGHT_REVIEW"] = "flight_review";
    SelectedTravelOfferScreen["FLIGHT_CHECKOUT"] = "flight_checkout";
    SelectedTravelOfferScreen["HOTEL_SEARCH"] = "hotel_search";
    SelectedTravelOfferScreen["HOTEL_SHOP"] = "hotel_shop";
    SelectedTravelOfferScreen["HOTEL_CUSTOMIZE"] = "hotel_customize";
    SelectedTravelOfferScreen["HOTEL_DETAILS"] = "hotel_details";
    SelectedTravelOfferScreen["HOTEL_CHECKOUT"] = "hotel_checkout";
    SelectedTravelOfferScreen["CARS_SEARCH"] = "cars_search";
    SelectedTravelOfferScreen["CARS_SHOP"] = "cars_shop";
    SelectedTravelOfferScreen["CARS_REVIEW"] = "cars_review";
    SelectedTravelOfferScreen["CARS_CHECKOUT"] = "cars_checkout";
    SelectedTravelOfferScreen["TRAVEL_WALLET_LANDING"] = "travel_wallet_landing";
    SelectedTravelOfferScreen["PREMIUM_STAYS_SHOP"] = "premium_stays_shop";
    SelectedTravelOfferScreen["PREMIUM_STAYS_CUSTOMIZE"] = "premium_stays_customize";
    SelectedTravelOfferScreen["PREMIUM_STAYS_DETAILS"] = "premium_stays_details";
    SelectedTravelOfferScreen["PREMIUM_STAYS_CHECKOUT"] = "premium_stays_checkout";
    SelectedTravelOfferScreen["PACKAGES_AVAILABILITY"] = "packages_availability";
    SelectedTravelOfferScreen["PACKAGES_CHECKOUT"] = "packages_checkout";
    SelectedTravelOfferScreen["PACKAGES_HOTEL_SHOP"] = "packages_hotel_shop";
    SelectedTravelOfferScreen["PACKAGES_FLIGHT_SHOP"] = "packages_flight_shop";
    SelectedTravelOfferScreen["EXPERIENCES_SEARCH"] = "experiences_search";
    SelectedTravelOfferScreen["EXPERIENCES_SHOP"] = "experiences_shop";
    SelectedTravelOfferScreen["EXPERIENCES_CHECKOUT"] = "experiences_checkout";
    SelectedTravelOfferScreen["HOMES_SHOP"] = "homes_shop";
})(SelectedTravelOfferScreen || (SelectedTravelOfferScreen = {}));
export var VIEWED_OFFERS_LIST = "viewed_offers_list";
export var VIEWED_OFFER_FAQ = "viewed_offer_faq";
export var ENGAGED_OFFER_CTA = "engaged_offer_cta";
export var VIEWED_OFFER_BANNER = "viewed_offer_banner";
// Travel sale
export var VIEWED_SALE_PAGE = "viewed_sale_page";
export var SALE_FILTER_APPLIED = "sale_filter_applied";
export var VIEWED_SALE_OFFER_MODAL = "viewed_sale_offer_modal";
export var CLICKED_SALE_OFFER_CTA = "clicked_sale_offer_cta";
// DP User Preferences
export var DISRUPTION_OPT_IN_EVENT_NAME = "messaging_opt_in";
export var DISRUPTION_SOURCE = "disruption";
// DP Exercise Events
export var SELECTED_DISRUPTION = "selected_disruption";
export var VIEWED_DISRUPTION_PAGE = "viewed_disruption_page";
export var MISSED_CONNECTION_REDEEM = "missed_connection_redeem";
export var DELAYS_REDEEM = "delays_redeem";
export var DISRUPTION_REDEEM_CHOICE_REFUND = "disruption_redeem_choice_refund";
export var DISRUPTION_REDEEM_CHOICE_REBOOK = "disruption_redeem_choice_rebook";
export var VIEWED_REFUND_CHOICE = "viewed_refund_choice";
export var CONFIRM_REFUND_CHOICE = "confirm_refund_choice";
export var CAP1_DISRUPTION_POLICY_EXERCISED = "cap1_disruption_policy_exercised";
export var CAP1_VIEWED_REBOOKING_CHOICE = "cap1_viewed_rebooking_choice";
export var CAP1_SELECTED_REBOOKING_CHOICE = "cap1_selected_rebooking_choice";
export var CAP1_VIEWED_REBOOKING_FLIGHT_LIST = "cap1_viewed_rebooking_flight_list";
export var CAP1_REBOOKING_VIEWED_SLICE = "cap1_rebooking_viewed_slice";
export var CAP1_REBOOKING_CONFIRMED_SLICE = "cap1_rebooking_confirmed_slice";
export var CAP1_REBOOKING_REVIEW_DETAILS = "cap1_rebooking_review_details";
export var CAP1_REBOOKING_COMPLETE_BUY = "cap1_rebooking_complete_buy";
export var getPartialEligibilityDpExerciseFactsPropertiesFromEligibility = function (eligibility) {
    var disruptedSlice = (function () {
        switch (eligibility === null || eligibility === void 0 ? void 0 : eligibility.ExerciseEligibilityV1) {
            case ExerciseEligibilityV1Enum.IsEligible:
                return getEligibleSliceFromEligibility(eligibility);
            case ExerciseEligibilityV1Enum.NotEligible:
            default:
                return undefined;
        }
    })();
    var disruptedSegment = disruptedSlice === null || disruptedSlice === void 0 ? void 0 : disruptedSlice.slice.segments.find(function (segment) {
        return segment.EligibilitySegment === EligibilitySegmentEnum.IsEligible;
    });
    var reasons = (function () {
        var disruption = disruptedSegment === null || disruptedSegment === void 0 ? void 0 : disruptedSegment.disruption;
        switch (disruption === null || disruption === void 0 ? void 0 : disruption.FlightDisruption) {
            case FlightDisruptionEnum.IsDisrupted:
                return disruption.reasons;
            default:
                return undefined;
        }
    })();
    if (reasons) {
        var reason = reasons[0];
        switch (reason === null || reason === void 0 ? void 0 : reason.Reason) {
            case FlightDisruptionReasonEnum.Delayed:
                return {
                    active_disruption: "delay",
                    // note: use dayjs here to convert the duration into seconds; though we might need to know whether we want to add dayjs as a dependency or not.
                    delay_duration: reason.inMinutes * 60,
                };
            case FlightDisruptionReasonEnum.MissedConnection:
                return {
                    active_disruption: "missed_connection",
                    delay_duration: reason.inMinutes * 60,
                };
            case FlightDisruptionReasonEnum.AirlineCancellation:
                return {
                    active_disruption: "involuntary_cancel",
                    delay_duration: "none",
                };
            default:
                return {
                    active_disruption: "none",
                    delay_duration: "none",
                };
        }
    }
    return {
        active_disruption: "none",
        delay_duration: "none",
    };
};
// LUXURY OFFER PROMOTION EVENTS
export var VIEWED_LUXURY_OFFER_PROMOTION_BANNER = "viewed_luxury_offer_promotion_banner";
export var CLICKED_LUXURY_OFFER_PROMOTION_CTA = "clicked_luxury_offer_promotion_cta";
// LUXURY COMP NIGHT EVENTS
export var VIEWED_COMP_NIGHT_BANNER = "viewed_comp_night_banner";
export var ViewedCompNightBannerEntryPoint;
(function (ViewedCompNightBannerEntryPoint) {
    ViewedCompNightBannerEntryPoint["PREMIUM_STAYS_LANDING"] = "premium_stays_landing";
    ViewedCompNightBannerEntryPoint["FLIGHT_CONFIRMATION"] = "flight_confirmation";
    ViewedCompNightBannerEntryPoint["CAR_CONFIRMATION"] = "car_confirmation";
    ViewedCompNightBannerEntryPoint["WALLET_DRAWER_AIR"] = "wallet_drawer_air";
    ViewedCompNightBannerEntryPoint["WALLET_DRAWER_HOTELS"] = "wallet_drawer_hotels";
    ViewedCompNightBannerEntryPoint["WALLET_DRAWER_CARS"] = "wallet_drawer_cars";
    ViewedCompNightBannerEntryPoint["WALLET_DRAWER_PREMIUM_STAYS"] = "wallet_drawer_premium_stays";
    ViewedCompNightBannerEntryPoint["WALLET_DRAWER_EXPERIENCES"] = "wallet_drawer_experiences";
    ViewedCompNightBannerEntryPoint["MY_TRAVEL_CREDITS_OFFERS"] = "my_travel_credits_offers";
})(ViewedCompNightBannerEntryPoint || (ViewedCompNightBannerEntryPoint = {}));
export var VIEWED_PREMIUM_OFFER_PAGE = "viewed_premium_offer_page";
export var SEARCHED_PREMIUM_OFFERS = "searched_premium_offers";
export var FILTER_APPLIED_PREMIUM_OFFERS = "filter_applied_premium_offer";
export var PremiumOffersFilterType;
(function (PremiumOffersFilterType) {
    PremiumOffersFilterType["ALL"] = "All";
    PremiumOffersFilterType["CITY"] = "City";
    PremiumOffersFilterType["OUTDOORS"] = "Outdoors";
    PremiumOffersFilterType["WELLNESS"] = "Wellness";
    PremiumOffersFilterType["ARTS_AND_CULTURE"] = "Arts & culture";
    PremiumOffersFilterType["BEACH"] = "Beach";
})(PremiumOffersFilterType || (PremiumOffersFilterType = {}));
export var SELECTED_HOTEL_FROM_PREMIUM_OFFER_LIST = "selected_hotel_from_premium_offer_list";
export var SelectedHotelOfferState;
(function (SelectedHotelOfferState) {
    SelectedHotelOfferState["LOCKED"] = "locked";
    SelectedHotelOfferState["UNLOCKED"] = "unlocked";
    SelectedHotelOfferState["UNAVAILABLE"] = "unavailable";
})(SelectedHotelOfferState || (SelectedHotelOfferState = {}));
// PC EVENTS
// HOTEL EVENTS
export var LC_ENTRY = "lc_entry";
export var PC_ENTRY = "pc_entry";
export var VIEWED_PC_LIST = "viewed_pc_list";
export var VIEWED_UNAVAILABLE_PC_LIST = "viewed_unavailable_pc_list";
export var APPLIED_PC_FILTER = "applied_pc_filter";
export var SELECTED_PC_FROM_LIST = "selected_pc_from_list";
export var SELECTED_PC_FROM_MAP = "selected_pc_from_map";
export var SELECTED_LC_FROM_LIST = "selected_lc_from_list";
export var SELECTED_LC_FROM_MAP = "selected_lc_from_map";
export var VIEWED_DATELESS_HOTEL_DETAILS = "viewed_dateless_hotel_details";
export var VIEWED_UNAVAILABLE_DATELESS_HOTEL_DETAILS = "viewed_unavailable_dateless_hotel_details";
export var VIEWED_LC_DETAILS = "viewed_lc_details";
export var VIEWED_PC_DETAILS = "viewed_pc_details";
export var SELECT_LC_ROOM = "select_lc_room";
export var SELECT_PC_ROOM = "select_pc_room";
export var REVIEW_DETAILS_LC_CHECKOUT = "review_details_lc_checkout";
export var REVIEW_DETAILS_PC_CHECKOUT = "review_details_pc_checkout";
export var PC_SAVE_AND_CONTINUE_CLICKED = "pc_save_and_continue_clicked";
export var PRICE_QUOTE_LC = "price_quote_lc";
export var PRICE_QUOTE_PC = "price_quote_pc";
export var COMPLETE_BUY_LC = "complete_buy_lc";
export var COMPLETE_BUY_PC = "complete_buy_pc";
export var PAYMENT_SCHEDULE_SELECTED = "payment_schedule_selected";
export var VIEWED_PAYMENT_SCHEDULE_MODAL = "viewed_payment_schedule_modal";
// MEGAMENU EVENTS
export var MEGA_MENU_ENTRY = "mega_menu_entry";
export var MEGA_MENU_SELECTED_NODE = "megu_menu_selected_node";
export var MegaMenuNodeType;
(function (MegaMenuNodeType) {
    MegaMenuNodeType["ROOT"] = "root";
    MegaMenuNodeType["SUBSECTION"] = "subsection";
    MegaMenuNodeType["LEAF"] = "leaf";
})(MegaMenuNodeType || (MegaMenuNodeType = {}));
// VR EVENTS
export var VR_TOGGLE_SELECTED = "vr_toggle_selected";
export var VR_ENTRY = "vr_entry";
export var VIEWED_PREMIUM_SEARCH = "viewed_premium_search";
export var VIEWED_VR_LIST = "viewed_vr_list";
export var SELECTED_VR_FROM_LIST = "selected_vr_from_list";
export var SELECTED_VR_FROM_MAP = "selected_vr_from_map";
export var VIEWED_VR_DETAILS = "viewed_vr_details";
export var VIEWED_VR_DETAILS_PHOTO_GALLERY = "viewed_vr_details_photo_gallery";
export var VR_DETAILS_PHOTO_GALLERY_IMAGE_LOAD_ERROR = "vr_details_photo_gallery_image_load_error";
export var REVIEW_DETAILS_VR_CHECKOUT = "review_details_vr_checkout";
export var COMPLETE_BUY_VR = "complete_buy_vr";
// CREDITS TRACKING
export var VIEWED_CREDIT_BANNER = "viewed_credit_banner";
export var ENGAGED_CREDIT_CTA = "engaged_credit_cta";
export var VIEW_CREDIT_HISTORY = "view_credit_history";
export var VIEW_TRAVEL_WALLET = "view_travel_wallet";
export var VIEWED_CREDIT_BENEFITS_MODAL = "viewed_credits_benefits_modal";
var getHotelCfarOfferFactsFromRefundableRoomProduct = function (_a) {
    var _b;
    var refundableRoomProduct = _a.refundableRoomProduct, cfar_room_card_offer = _a.cfar_room_card_offer, cfar_choice = _a.cfar_choice;
    if (!!(refundableRoomProduct === null || refundableRoomProduct === void 0 ? void 0 : refundableRoomProduct.roomProductVariant) &&
        refundableRoomProduct.roomProductVariant.variant ===
            RoomProductType.RefundableRoom) {
        var totalDiscountAware = refundableRoomProduct.totalDiscountAware, total = refundableRoomProduct.total;
        var _c = refundableRoomProduct.roomProductVariant, premiumPrices = _c.premiumPrices, pricingDescription = _c.pricingDescription, additionalInfo = _c.additionalInfo;
        var isCfarFeeRefundable = additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.shouldRefundCfarPremium;
        return {
            cfar_premium_percentage: total.fiat.value > 0
                ? Math.round((premiumPrices.fiat.value * 100) / total.fiat.value)
                : undefined,
            cfar_premium_usd: premiumPrices.fiat.value,
            cfar_pricing_description: pricingDescription,
            cfar_rr_price_total_usd: (_b = totalDiscountAware === null || totalDiscountAware === void 0 ? void 0 : totalDiscountAware.priceWithUnmanagedDiscounts.fiat.value) !== null && _b !== void 0 ? _b : total.fiat.value,
            cfar_room_card_offer: cfar_room_card_offer,
            cfar_choice: cfar_choice,
            cfar_fee_is_refundable: isCfarFeeRefundable,
        };
    }
    return { cfar_room_card_offer: cfar_room_card_offer, cfar_choice: cfar_choice };
};
var getHotelCfarOfferFactsFromHotelCfarQuote = function (_a) {
    var roomProduct = _a.roomProduct, hotelCfarQuote = _a.hotelCfarQuote, additionalInfo = _a.additionalInfo, cfar_room_card_offer = _a.cfar_room_card_offer, cfar_choice = _a.cfar_choice, hasAddedCfarFromModal = _a.hasAddedCfarFromModal;
    var isCfarFeeRefundable = additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.shouldRefundCfarPremium;
    if (!roomProduct) {
        return {
            cfar_room_card_offer: cfar_room_card_offer,
            cfar_choice: cfar_choice,
            cfar_fee_is_refundable: isCfarFeeRefundable,
        };
    }
    if (hotelCfarQuote) {
        var total = roomProduct.total;
        var premiumPrices = hotelCfarQuote.premiumPrices, pricingDescription = hotelCfarQuote.pricingDescription, coverageAmount = hotelCfarQuote.coverageAmount, expirationDate = hotelCfarQuote.expirationDate;
        return {
            cfar_premium_percentage: total.fiat.value > 0
                ? Math.round((premiumPrices.fiat.value * 100) / total.fiat.value)
                : undefined,
            cfar_premium_usd: premiumPrices.fiat.value,
            cfar_pricing_description: pricingDescription,
            cfar_room_card_offer: cfar_room_card_offer,
            cfar_choice: cfar_choice,
            cfar_fee_is_refundable: isCfarFeeRefundable,
            cfar_added_from_modal: hasAddedCfarFromModal,
            cfar_refund_promise_usd: coverageAmount.amount,
            cfar_refund_promise: coverageAmount.amount,
            cfar_cancellation_window: expirationDate,
        };
    }
    return {
        cfar_room_card_offer: cfar_room_card_offer,
        cfar_choice: cfar_choice,
        cfar_fee_is_refundable: isCfarFeeRefundable,
    };
};
export var getViewedHotelDetailsHotelCfarOfferFacts = function (refundableRoomProduct) {
    var hotelCfarOfferFacts = getHotelCfarOfferFactsFromRefundableRoomProduct({
        refundableRoomProduct: refundableRoomProduct,
    });
    return {
        cfar_premium_percentage: hotelCfarOfferFacts.cfar_premium_percentage,
        cfar_premium_usd: hotelCfarOfferFacts.cfar_premium_usd,
        cfar_pricing_description: hotelCfarOfferFacts.cfar_pricing_description,
        cfar_rr_price_total_usd: hotelCfarOfferFacts.cfar_rr_price_total_usd,
    };
};
export var getSelectHotelRoomHotelCfarOfferFacts = function (props) {
    return getHotelCfarOfferFactsFromRefundableRoomProduct(props);
};
export var CAP1_HOTEL_VIEWED_ADD_ON = "cap1_hotel_viewed_add_on";
export var getHotelViewedAddOnHotelCfarOfferFacts = function (roomProduct, hotelCfarQuote, additionalInfo) {
    var hotelCfarOfferFacts = getHotelCfarOfferFactsFromHotelCfarQuote({
        roomProduct: roomProduct,
        hotelCfarQuote: hotelCfarQuote,
        additionalInfo: additionalInfo,
    });
    return {
        cfar_premium_percentage: hotelCfarOfferFacts.cfar_premium_percentage,
        cfar_premium_usd: hotelCfarOfferFacts.cfar_premium_usd,
        cfar_pricing_description: hotelCfarOfferFacts.cfar_pricing_description,
        cfar_fee_is_refundable: hotelCfarOfferFacts.cfar_fee_is_refundable,
    };
};
export var CAP1_HOTEL_CFAR_ADD_ON_CHOICE = "cap1_hotel_cfar_add_on_choice";
export var getHotelCfarAddOnChoiceHotelCfarOfferFacts = function (props) {
    var hotelCfarOfferFacts = getHotelCfarOfferFactsFromHotelCfarQuote(props);
    return {
        cfar_premium_percentage: hotelCfarOfferFacts.cfar_premium_percentage,
        cfar_premium_usd: hotelCfarOfferFacts.cfar_premium_usd,
        cfar_pricing_description: hotelCfarOfferFacts.cfar_pricing_description,
        cfar_choice: hotelCfarOfferFacts.cfar_choice,
        cfar_room_card_offer: hotelCfarOfferFacts.cfar_room_card_offer,
        cfar_fee_is_refundable: hotelCfarOfferFacts.cfar_fee_is_refundable,
    };
};
export var getReviewDetailsHotelCheckoutHotelCfarOfferFacts = function (props) {
    var hotelCfarOfferFacts = getHotelCfarOfferFactsFromHotelCfarQuote(props);
    return {
        cfar_premium_percentage: hotelCfarOfferFacts.cfar_premium_percentage,
        cfar_premium_usd: hotelCfarOfferFacts.cfar_premium_usd,
        cfar_pricing_description: hotelCfarOfferFacts.cfar_pricing_description,
        cfar_choice: hotelCfarOfferFacts.cfar_choice,
        cfar_room_card_offer: hotelCfarOfferFacts.cfar_room_card_offer,
        cfar_fee_is_refundable: hotelCfarOfferFacts.cfar_fee_is_refundable,
    };
};
export var getCompleteBuyHotelHotelCfarOfferFacts = function (props) {
    var hotelCfarOfferFacts = getHotelCfarOfferFactsFromHotelCfarQuote(props);
    return {
        cfar_premium_percentage: hotelCfarOfferFacts.cfar_premium_percentage,
        cfar_premium_usd: hotelCfarOfferFacts.cfar_premium_usd,
        cfar_pricing_description: hotelCfarOfferFacts.cfar_pricing_description,
        cfar_choice: hotelCfarOfferFacts.cfar_choice,
        cfar_room_card_offer: hotelCfarOfferFacts.cfar_room_card_offer,
        cfar_fee_is_refundable: hotelCfarOfferFacts.cfar_fee_is_refundable,
        cfar_added_from_modal: hotelCfarOfferFacts.cfar_added_from_modal,
        cfar_refund_promise_usd: hotelCfarOfferFacts.cfar_refund_promise_usd,
        cfar_refund_promise: hotelCfarOfferFacts.cfar_refund_promise,
        cfar_cancellation_window: hotelCfarOfferFacts.cfar_cancellation_window,
    };
};
export var PRODUCT_FEED_LOADING = "product_feed_loading";
export var PRODUCT_FEED_VIEWED_EVENT = "product_feed_viewed";
export var PRODUCT_FEED_RENDERED_EVENT = "product_feed_rendered";
export var PRODUCT_FEED_TILE_TAPPED = "prodfeed_tile_tapped";
export var PRODUCT_FEED_NOT_RENDERED_EVENT = "product_feed_not_rendered";
export var VIEWED_MISSED_CONNECTION_GUARANTEE_MODAL = "viewed_missed_connection_guarantee_modal";
export var VIEWED_SELF_TRANSFER_MODAL = "viewed_self_transfer_modal";
export var VIEWED_VI_BAGGAGE_WARNING = "viewed_vi_baggage_warning";
export var CONFIRMED_VI_BAGGAGE_WARNING = "confirmed_vi_baggage_warning";
export var DECLINED_VI_BAGGAGE_WARNING = "declined_vi_baggage_warning";
export var EXPANDED_FLIGHT_DETAILS = "expanded_flight_details";
export var VIEWED_FARE_DETAILS_BREAKDOWN = "viewed_fare_details_breakdown";
export var ALL_FILTERS_MODAL_CARS_EVENT = "all_filters_modal_cars";
export var VirtualInterlineEntryPoint;
(function (VirtualInterlineEntryPoint) {
    VirtualInterlineEntryPoint["Outbound"] = "outbound";
    VirtualInterlineEntryPoint["Return"] = "return";
    VirtualInterlineEntryPoint["Details"] = "itinerary_details";
    VirtualInterlineEntryPoint["TripDetails"] = "trip_details";
})(VirtualInterlineEntryPoint || (VirtualInterlineEntryPoint = {}));
export var SELECT_EDIT_TRAVELERS = "select_edit_travelers";
export var VIEW_BOOKING_ADD_ON_POST_BOOKING = "cap1_view_booking_add_on_post_booking";
export var SELECTED_POST_BOOKING_CFAR_OFFER = "cap1_selected_post_booking_cfar_offer";
export var REVIEW_DETAILS_CFAR_POST_BOOKING = "cap1_review_details_fintech_checkout";
export var DISRUPTION_ADD_ON_CHOICE_POST_BOOKING = "cap1_disruption_add_on_choice_post_booking";
export var DISRUPTION_POST_BOOKING_COMPLETE_BUY = "cap1_disruption_post_booking_complete_buy";
export var CFAR_POST_BOOKING_COMPLETE_BUY = "cap1_cfar_post_booking_complete_buy";
export var getPostBookingScreen = function (locationSearch) {
    var _a;
    var screens = [
        "air_homepage",
        "hotel_homepage",
        "my_trips_homepage",
    ];
    var referenceScreenString = new URLSearchParams(locationSearch).get("referenceScreen");
    return (_a = screens.find(function (str) { return str == referenceScreenString; })) !== null && _a !== void 0 ? _a : "air_homepage";
};
export var postBookingViewTakeoverPropteries = function (screen, takeover_display_count, trackingProperties) {
    return {
        eventName: VIEW_BOOKING_ADD_ON_POST_BOOKING,
        properties: __assign({ screen: screen, takeover_display_count: takeover_display_count }, trackingProperties),
    };
};
export var postBookingViewCheckoutScreenProperties = function (screen, trackingProperties, offerDeeplink) {
    return {
        eventName: VIEW_BOOKING_ADD_ON_POST_BOOKING,
        properties: __assign({ referring_screen: screen, offer_deeplink: offerDeeplink, screen: "fda_postbooking_checkout" }, trackingProperties),
    };
};
export var postBookingChoiceTappedProperties = function (screen, disruption_choice, trackingProperties, offerDeeplink) {
    return {
        eventName: DISRUPTION_ADD_ON_CHOICE_POST_BOOKING,
        properties: __assign({ screen: screen, offer_deeplink: offerDeeplink, disruption_choice: disruption_choice }, trackingProperties),
    };
};
export var postBookingPurchaseCompleteProperties = function (args) {
    return {
        eventName: DISRUPTION_POST_BOOKING_COMPLETE_BUY,
        properties: __assign({ referring_screen: args.screen, offer_deeplink: args.offerDeeplink, screen: "fda_postbooking_checkout", disruption_choice: 1 }, args.trackingProperties),
    };
};
// Customer profile
export var CUSTOMER_PROFILE_ENTRY = "customer_profile_entry";
export var APPLIED_PREFERENCES = "applied_preferences";
export var CLEAR_ALL_FILTERS = "clear_all_filters";
export var CLICKED_ADD_TRAVELER = "clicked_add_traveler";
export var SAVED_NEW_TRAVELER = "saved_new_traveler";
export var SAVED_FLIGHT_PREFERENCES = "saved_flight_preferences";
export var SAVED_HOTEL_PREFERENCES = "saved_hotel_preferences";
export var NEW_PAYMENT_METHOD_ADDED = "new_payment_method_added";
// Corporate Travel
export var VIEWED_POLICY_MODAL = "viewed_policy_modal";
export var VIEWED_POLICY_DESCRIPTOR = "viewed_policy_descriptor";
export var POLICY_MODAL = "policy_modal";
export var POLICY_DESCRIPTOR = "policy_descriptor";
export var PolicyDescriptorEntryPoints;
(function (PolicyDescriptorEntryPoints) {
    PolicyDescriptorEntryPoints["FLIGHTS_LIST"] = "flights_list";
    PolicyDescriptorEntryPoints["FLIGHTS_LIST_EXPANDED"] = "flights_list_expanded";
    PolicyDescriptorEntryPoints["FLIGHTS_LIST_RETURN"] = "flights_list_return";
    PolicyDescriptorEntryPoints["FLIGHTS_LIST_RETURN_EXPANDED"] = "flights_list_return_expanded";
    PolicyDescriptorEntryPoints["HOTELS_LIST"] = "hotels_list";
    PolicyDescriptorEntryPoints["HOTELS_ROOM_DETAILS"] = "hotels_room_details";
    PolicyDescriptorEntryPoints["CARS_LIST"] = "cars_list";
})(PolicyDescriptorEntryPoints || (PolicyDescriptorEntryPoints = {}));
export var VIEWED_TRAVELER_DETAILS = "viewed_traveler_details";
export var CREATED_TRAVELER_PROFILE = "created_traveler_profile";
export var UPDATED_TRAVELER_PROFILE = "updated_traveler_profile";
export var PRICE_MATCH_CLICKED = "price_match_clicked";
export var PORTAL_SWITCHED = "portal_switched";
export var VIEWED_ITEMIZED_RECEIPT = "viewed_itemized_receipt";
export var PRINTED_ITEMIZED_RECEIPT = "printed_itemized_receipt";
export var VIEWED_LODGING_RESERVATION_IN_LIST = "viewed_lodging_reservation_in_list";
export var VIEWED_TRAVEL_OFFER = "viewed_travel_offer";
export var VIEWED_CORP_RATE_DESCRIPTOR = "viewed_corporate_rate_descriptor";
export var ViewedCorpRateDescriptorEntryPoints;
(function (ViewedCorpRateDescriptorEntryPoints) {
    ViewedCorpRateDescriptorEntryPoints["HOTELS_LIST_HEADER"] = "hotels_list_header";
    ViewedCorpRateDescriptorEntryPoints["HOTELS_LIST_CARD"] = "hotels_list_card";
    ViewedCorpRateDescriptorEntryPoints["HOTELS_LIST_MAP"] = "hotels_list_map";
    ViewedCorpRateDescriptorEntryPoints["HOTELS_ROOM_DETAILS"] = "hotels_room_details";
    ViewedCorpRateDescriptorEntryPoints["HOTELS_CHECKOUT"] = "hotels_checkout";
})(ViewedCorpRateDescriptorEntryPoints || (ViewedCorpRateDescriptorEntryPoints = {}));
export var CORP_SWITCH_ACCOUNT = "switch_account";
export var CORP_SWITCH_ACCOUNT_CONTINUE = "switch_account_continue";
export var CORP_BUSINESS_LOYALTY_ADDED = "business_loyalty_added";
export var VXB_ACKNOWLEDGED = "vxb_acknowledged";
export var TAKEOVER_NOTICE_VIEWED = "takeover_notice_viewed";
export var HOTEL_BOOK_AGAIN = "hotel_book_again";
export var HotelBookAgainSourceEnum;
(function (HotelBookAgainSourceEnum) {
    HotelBookAgainSourceEnum["MyTrips"] = "my_trips";
    HotelBookAgainSourceEnum["Confirmation"] = "confirmation";
})(HotelBookAgainSourceEnum || (HotelBookAgainSourceEnum = {}));
// PACKAGES EVENTS
export var PACKAGE_ENTRY = "package_entry";
export var VIEWED_PACKAGES_SEARCH = "viewed_packages_search";
export var VIEWED_PACKAGES_LIST = "viewed_packages_list";
export var APPLIED_PACKAGES_FILTER = "applied_packages_filter";
export var SELECTED_PACKAGE_HOTEL_FROM_LIST = "selected_package_hotel_from_list";
export var SELECTED_PACKAGE_HOTEL_FROM_MAP = "selected_package_hotel_from_map";
export var VIEWED_PACKAGE_LODGING_IN_LIST = "viewed_package_lodging_in_list";
export var SELECTED_UNAVAILABLE_PACKAGE_HOTEL_FROM_LIST = "selected_unavailable_package_hotel_from_list";
export var COMPLETE_BUY_PACKAGE = "complete_buy_package";
export var PRICE_QUOTE_PACKAGE = "price_quote_package";
export var VIEWED_PACKAGE_CHECKOUT = "viewed_package_checkout";
export var VIEWED_PACKAGE_HOTEL_SHOP_LOADING = "viewed_packages_hotel_shop_loading";
export var VIEWED_PACKAGE_HOTEL_SHOP_MAP = "viewed_packages_hotel_shop_map";
export var VIEWED_PACKAGE_HOTEL_AVAILABILITY_MAP = "viewed_package_hotel_availability_map";
export var NAVIGATED_BACK_TO_PACKAGE_HOTEL_LIST = "navigated_back_to_package_hotel_list";
export var SELECT_PACKAGE_HOTEL_ROOM = "select_package_hotel_room";
export var VIEWED_ITINERARY_REVIEW = "viewed_itinerary_review";
export var REVIEWED_FLIGHT_DETAILS = "reviewed_flight_details";
export var PACKAGES_REVIEW_PAGE_CHANGE_HOTEL_SELECTED = "change_hotel_selected";
export var HOTELS_CLICKED_CHANGE_RESERVATION = "hotel_clicked_change_reservation";
export var CHANGE_ROOM_SELECTED = "change_room_selected";
export var CHANGE_FLIGHT_SELECTED = "change_flight_selected";
export var REDIRECT_TO_PACKAGE_HOTEL_SHOP = "redirect_to_package_hotel_shop";
export var PACKAGES_CHECKOUT_HANDOFF_FAILED = "packages_checkout_handoff_failed";
export var SELECTED_PACKAGE_FLIGHT_PAX = "selected_package_flight_pax";
export var SELECTED_PACKAGE_PRIMARY_TRAVELER = "selected_package_primary_traveler";
export var VIEWED_PACKAGE_CHECKOUT_PAYMENTS = "viewed_package_checkout_payments";
export var VIEWED_PACKAGE_CONFIRM_AND_BOOK = "viewed_package_confirm_and_book";
export var VIEWED_PACKAGE_CHECKOUT_BREAKDOWN = "viewed_package_checkout_breakdown";
export var CLICKED_ACTIVITIES_HEADER = "clicked_activities_header";
export var ACTIVITIES_ENTRY = "activities_entry";
export var ActivitiesEntryTypeMap;
(function (ActivitiesEntryTypeMap) {
    ActivitiesEntryTypeMap[ActivitiesEntryTypeMap["HOMEPAGE"] = 0] = "HOMEPAGE";
    ActivitiesEntryTypeMap[ActivitiesEntryTypeMap["ACTIVITIES_XSELL"] = 1] = "ACTIVITIES_XSELL";
    ActivitiesEntryTypeMap[ActivitiesEntryTypeMap["STAYS_XSELL"] = 2] = "STAYS_XSELL";
})(ActivitiesEntryTypeMap || (ActivitiesEntryTypeMap = {}));
export var ACTIVITIES_SEARCHED_REVIEWS = "activities_searched_reviews";
export var VIEWED_ACTIVITY_IN_LIST = "viewed_activity_in_list";
export var VIEWED_ACTIVITY_DETAILS = "viewed_activity_details";
export var VIEWED_ACTIVITIES_CHECKOUT = "viewed_activities_checkout";
export var ACTIVITY_EXIT_SURVEY_SHOWN = "activity_exit_survey_shown";
export var ACTIVITY_EXIT_SURVEY_OPENED = "activity_exit_survey_opened";
export var ACTIVITY_EXIT_SURVEY_DISMISSED = "activity_exit_survey_dismissed";
export var ACTIVITY_EXIT_ANSWERED_QUESTION = "activity_exit_survey_answered_question";
export var ACTIVITIES_VIEWED_PHOTOS = "activities_viewed_photos";
export var ACTIVITIES_APPLIED_FILTER = "activities_applied_filter";
export var ACTIVITIES_TAG_SELECTED = "activities_tag_selected";
export var PRICE_QUOTE_ACTIVITY = "activities_pq";
export var COMPLETE_BUY_ACTIVITY = "complete_buy_activities";
export var ACTIVITIES_SHOP_OPTION = "activities_shop_option";
export var VIEWED_SIMILAR_ACTIVITIES = "viewed_similar_activities";
export var CLICKED_SIMILAR_ACTIVITIES = "clicked_similar_activities";
export var VIEWED_COMPARE_ITINERARIES = "viewed_compare_itineraries";
export var ACTIVITIES_AUTOCOMPLETE_FOCUSED = "activities_autocomplete_focused";
export var ACTIVITIES_AUTOCOMPLETE_TYPED = "activities_autocomplete_typed";
export var ACTIVITIES_AUTOCOMPLETE_SUGGESTION_CLICKED = "activities_autocomplete_suggestion_clicked";
export var ActivitiesAutocompleteSuggestionType = {
    Trip: "trip",
    Search: "search",
    RecentSearch: "recent_search",
    Nearby: "nearby",
};
// Secondary search (availability page keyword search) events
export var ACTIVITIES_SECONDARY_SEARCH_FOCUSED = "activities_secondary_search_focused";
export var ACTIVITIES_SECONDARY_SEARCH_TYPED = "activities_secondary_search_typed";
export var ACTIVITIES_SECONDARY_SEARCH_RESULT_CLICKED = "activities_secondary_search_result_clicked";
export var ActivitiesSecondarySearchResultType = {
    Category: "category",
    Attraction: "attraction",
    Activity: "activity",
};
// Dateless search events
export var ACTIVITIES_DATELESS_SELECT_DATES_CLICKED = "activities_dateless_select_dates_clicked";
export var ACTIVITIES_UNAVAILABLE_DATE_MODAL_OPENED = "activities_unavailable_date_modal_opened";
export var ACTIVITIES_UNAVAILABLE_DATE_MODAL_DISMISSED = "activities_unavailable_date_modal_dismissed";
export var ACTIVITIES_UNAVAILABLE_DATE_NEXT_DATE_SELECTED = "activities_unavailable_date_next_date_selected";
export var ACTIVITIES_UNAVAILABLE_DATE_VIEW_ALTERNATIVES = "activities_unavailable_date_view_alternatives";
export var CorporateReferralBannerSource;
(function (CorporateReferralBannerSource) {
    CorporateReferralBannerSource["Homepage"] = "homepage";
    CorporateReferralBannerSource["Confirmation"] = "confirmation";
})(CorporateReferralBannerSource || (CorporateReferralBannerSource = {}));
export var ENTERED_USEFULNESS_SCALE = "entered_usefulness_scale";
export var SUBMIT_FEEDBACK = "submit_feedback";
export var FAVORITES_ENTRY = "favorites_entry";
export var FAVORITES_VIEWED_MODAL = "favorites_viewed_modal";
export var FAVORITES_ADD_ITEM = "favorites_add_item";
export var FAVORITES_REMOVE_ITEM = "favorites_remove_item";
export var FAVORITES_CREATE_LIST = "favorites_create_list";
export var FAVORITES_VIEWED_LIST = "favorites_viewed_list";
export var FAVORITES_EDITED_LIST = "favorites_edited_list";
export var CUSTOMER_PROFILE_VIEWED_SECTION = "customer_profile_viewed_section";
export var APP_GTM_ENTRY = "app_gtm_entry";
export var APP_GTM_EXIT = "app_gtm_exit";
export var TRAVEL_APP_INTERFACE_EVENT = "travel_app_interface_event";
// PAYMENT FLEX SMOKE TEST (cot_payment_flex_survey)
export var PAY_FLEX_SURVEY_LINK_VIEWED = "pay_flex_survey_link_viewed";
export var PAY_FLEX_SURVEY_CHOICES_VIEWED = "pay_flex_survey_choices_viewed";
export var PAY_FLEX_SURVEY_OPTION_TAPPED = "pay_flex_survey_option_tapped";
export var PAY_FLEX_SURVEY_SUBMITTED = "pay_flex_survey_submitted";
export var PAY_FLEX_SURVEY_DISMISSED = "pay_flex_survey_dismissed";
export var INSURANCE_OFFER_SHOWN = "insurance_offer_shown";
export var INSURANCE_OPT_IN_CLICKED = "insurance_opt_in_clicked";
export var INSURANCE_SURVEY_RESPONSE_SUBMITTED = "insurance_survey_response_submitted";
// TRIPS REPLATFORM NOTICE BANNER EVENTS
export var VIEWED_TRIPS_REPLATFORM_NOTICE = "viewed_trips_replatform_notice";
export var CLICKED_CLOSE_TRIPS_REPLATFORM_NOTICE = "clicked_close_trips_replatform_notice";
export var CLICKED_NAVIGATE_TO_PORTAL_TRIPS_REPLATFORM_NOTICE = "clicked_navigate_to_portal_trips_replatform_notice";
//# sourceMappingURL=events.js.map